import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftIndexResponse } from '@/repositories/generated';

const content: GiftIndexResponse[] = [
  {
    id: '1',
    name: '〇〇市プレミアム付商品券1',
    salesEndsAt: '2023-04-23T00:00:00+09:00',
    salesStartsAt: '2023-05-23T00:00:00+09:00',
    giftType: 'NORMAL',
    giftStatus: 'SCHEDULED_SALE',
    giftDetails: [
      {
        id: '1',
        name: '【赤券】（大型店・一般店で利用可能）',
        salesCount: 500,
        giftDetailExpiresAtStart: '2023-04-23T00:00:00+09:00',
        giftDetailExpiresAtEnd: '2023-05-23T00:00:00+09:00',
        createdAt: '2023-05-23T00:00:00+09:00',
      },
      {
        id: '2',
        name: '【青券】（一般店で利用可能）',
        salesCount: 500,
        giftDetailExpiresAtStart: '2023-04-23T00:00:00+09:00',
        giftDetailExpiresAtEnd: '2023-05-23T00:00:00+09:00',
        createdAt: '2023-05-23T00:00:00+09:00',
      },
    ],
  },
  {
    id: '2',
    name: '〇〇市給付金2',
    salesEndsAt: '2023-04-23T00:00:00+09:00',
    salesStartsAt: '2023-05-23T00:00:00+09:00',
    giftType: 'BENEFITS',
    giftStatus: 'SALE',
    giftDetails: [
      {
        id: '3',
        name: '【赤券】（大型店・一般店で利用可能）',
        salesCount: 10000,
        giftDetailExpiresAtStart: '2023-04-23T00:00:00+09:00',
        giftDetailExpiresAtEnd: '2023-05-23T00:00:00+09:00',
        createdAt: '2023-05-23T00:00:00+09:00',
      },
      {
        id: '4',
        name: '【青券】（一般店で利用可能）',
        salesCount: 1000,
        giftDetailExpiresAtStart: '2023-04-23T00:00:00+09:00',
        giftDetailExpiresAtEnd: '2023-05-23T00:00:00+09:00',
        createdAt: '2023-05-23T00:00:00+09:00',
      },
      {
        id: '5',
        name: '【緑券】（一般店で利用可能）',
        salesCount: 100,
        giftDetailExpiresAtStart: '2023-04-23T00:00:00+09:00',
        giftDetailExpiresAtEnd: '2023-05-23T00:00:00+09:00',
        createdAt: '2023-05-23T00:00:00+09:00',
      },
    ],
  },
  {
    id: '3',
    name: '〇〇市プレミアム付商品券3',
    salesEndsAt: '2023-04-23T00:00:00+09:00',
    salesStartsAt: '2023-05-23T00:00:00+09:00',
    giftType: 'NORMAL',
    giftStatus: 'SALE_END',
    giftDetails: [
      {
        id: '6',
        name: '【赤券】（大型店・一般店で利用可能）',
        salesCount: 500,
        giftDetailExpiresAtStart: '2023-04-23T00:00:00+09:00',
        giftDetailExpiresAtEnd: '2023-05-23T00:00:00+09:00',
        createdAt: '2023-05-23T00:00:00+09:00',
      },
    ],
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const gift = http.get(
  createMockEndpoint('/gift'),
  async () => {
    await delay(500);
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);

export default gift;
